export function getRelativeUrl(url: string | null | undefined) {
  if (!url?.startsWith("http")) {
    return url
  }

  const parsedUrl = new URL(url)

  return parsedUrl.pathname + parsedUrl.search
}

export function textToId(text: string): string {
  return text
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-zA-Z0-9]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase()
}
